// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lVJpK","left":"styles_left__2EKtu"};